module.exports = __webpack_public_path__ + "img/fc-red-bull-salzburg-fc.b8dc7496.png";